import {PlaceholderId} from '../../../../shared';

export const FILTER_SECTIONS = [PlaceholderId.Filters, PlaceholderId.DashboardFilters];
